import React, { useState, useEffect } from 'react';

import { APP_URL, SCREEN_SIZE } from 'types';
import {
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem
} from 'carbon-components-react';
import {
  WatsonHealthMagnify16,
  Email16,
  ReportData16,
  Settings16,
  UserMultiple16
} from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavAOAdminAdmin: React.FC<any> = ({ screenSize }) => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <div className="divider" />
      {/* Reporting */}
      <SideNavLink
        aria-current={pathname === APP_URL.REPORTS ? 'page' : undefined}
        renderIcon={ReportData16}
        onClick={() => history.push(`${APP_URL.REPORTS}`)}
      >
        Reporting
      </SideNavLink>
      {/* REFERRAL_HISTORY */}
      <SideNavLink
        renderIcon={WatsonHealthMagnify16}
        aria-current={
          pathname === APP_URL.REFERRAL_HISTORY ? 'page' : undefined
        }
        onClick={() => history.push(`${APP_URL.REFERRAL_HISTORY}`)}
      >
        Referral history
      </SideNavLink>
      <SideNavLink
        renderIcon={Email16}
        aria-current={
          pathname === APP_URL.REFERRALS_EMAILS ? 'page' : undefined
        }
        onClick={() => history.push(`${APP_URL.REFERRALS_EMAILS}`)}
      >
        Email history
      </SideNavLink>
      <div className="divider" />
      {screenSize &&
        [SCREEN_SIZE.MAX, SCREEN_SIZE.XL, SCREEN_SIZE.LG].includes(
          screenSize
        ) && (
          <>
            <SideNavLink
              renderIcon={UserMultiple16}
              aria-current={
                pathname === APP_URL.USERS_ADMIN ? 'page' : undefined
              }
              onClick={() => history.push(APP_URL.USERS_ADMIN)}
            >
              Manage users
            </SideNavLink>

            <div className="divider" />
          </>
        )}
      <SideNavMenu
        renderIcon={Settings16}
        title="Configuration"
        isActive={pathname.includes(APP_URL.CONFIGURE)}
        defaultExpanded={pathname.includes(APP_URL.CONFIGURE)}
      >
        {screenSize &&
          [SCREEN_SIZE.MAX, SCREEN_SIZE.XL, SCREEN_SIZE.LG].includes(
            screenSize
          ) && (
            <SideNavMenuItem
              isActive={pathname === APP_URL.ORGANISATION_PROFILE}
              onClick={() => history.push(APP_URL.ORGANISATION_PROFILE)}
            >
              Contact details
            </SideNavMenuItem>
          )}
        <SideNavMenuItem
          isActive={pathname === APP_URL.MANAGE_SAFETY_MESSAGE_AND_LOGO}
          onClick={() => history.push(APP_URL.MANAGE_SAFETY_MESSAGE_AND_LOGO)}
        >
          Safety message & logo
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname === APP_URL.MANAGE_REFERRAL_CHANNEL}
          onClick={() => history.push(APP_URL.MANAGE_REFERRAL_CHANNEL)}
        >
          Referral handling
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname === APP_URL.MANAGE_AOI}
          onClick={() => history.push(APP_URL.MANAGE_AOI)}
        >
          Area of Interest
        </SideNavMenuItem>
      </SideNavMenu>

      {/* Integrations */}
      <div className="divider" />
    </>
  );
};

export default LeftNavAOAdminAdmin;
